// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../app/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".legend-group .legend-text,.legend-group .legend-title{fill:var(--tbd-chart-text-color,#8f8f8f)}", ""]);
// Exports
module.exports = exports;
